import { Component, OnInit, ViewContainerRef, ElementRef, ViewChild } from '@angular/core';
import { Entity } from '../Classes/EntityClass';
import { AutoImportstatus } from '../Classes/AutoImportStatusClass';
import { CommonSearch } from '../Classes/CommonClass';
import { CommonService } from '../Services/CommonServices';
import { AutoImportService } from '../Services/AutoImportServices';
import { EntityService } from '../Services/EntityService';
import { IMyDpOptions, IMyInputFieldChanged, IMyDateModel } from 'mydatepicker';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import * as _ from 'underscore';

@Component({
  selector: 'AutoImportSearchComponent',
  templateUrl: '../AutoImportStatus/AutoImportSearch.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/fixedheader.css'],
  providers: [CommonService, AutoImportService]
})

export class AutoImportSearchComponent implements OnInit {
  _AutoImportStatus = new AutoImportstatus();
  _CommonSearch = new CommonSearch();
  innerWidth: number;
  tableRowWidth: number = 99;
  loading: boolean = false;
  isFirstTime: boolean = true;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';

  _displaypropertyname1: string = "";
  _displaypropertyname2: string = "";
  _SelectedText_1: string = "";
  _SelectedText_2: string = "";
  _SearchParm: string;
  pagedItems: any[];
  pager: any = {};


  public myDatePickerStartdateOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    editableDateField: false,
    inline: false,
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true
  };



  SearchdropFirst: any[] = [
    { Value: 'EntityCode', Text: 'EHID' },
    { Value: 'ServiceName', Text: 'Service/Jobs' },
  ]
  SearchdropSecond: any[] = [
    { Value: 'EntityCode', Text: 'EHID' },
    { Value: 'ServiceName', Text: 'Service/Jobs' },
  ]


  SearchResult: any = [];
  @ViewChild("inputBox") _el: ElementRef;
  @ViewChild("inputBoxtext") _el1: ElementRef;
  RoleID: string;

  constructor(private _CommonService: CommonService, private _EntityService: AutoImportService, private _router: Router, private Activeroute: ActivatedRoute, public toastr: ToastsManager, vcr: ViewContainerRef,
    private http: Http) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
    this.isFirstTime = true;
  }
  ngOnInit() {

    this.ChangeHeadeFooterColor();
    this._AutoImportStatus.QueryStringServerName = this.Activeroute.snapshot.params['ServiceName'];
    this._AutoImportStatus.QueryDecriptSName = JSON.parse(atob(this._AutoImportStatus.QueryStringServerName));

    this._AutoImportStatus.AutoImportSearchDate = { jsdate: new Date() };

    this._AutoImportStatus.SearchdropFirst = "-1";
    this._AutoImportStatus.SearchdropSecond = "-1";
    this._AutoImportStatus.SearchMatchesFirst = "Contains";
    this._AutoImportStatus.SearchMatchesSecond = "Contains";

    if (this._AutoImportStatus.QueryDecriptSName != "") {

      //this.GetDateByQueryString(this._AutoImportStatus.QueryDecriptSName);
    }


    //this._SearchParm = localStorage.getItem('SearchParm');
    //if (this._SearchParm != null) {

    //  this.ResetEntitySearch(this._SearchParm);
    //}

   
    //else {
    //  this._AutoImportStatus.AutoImportSearchDate = { jsdate: new Date() };
    //}

  }
  public GetEntitySearchAutocomplete = (SearchType: any, Searchstring: any): Observable<any[]> => {

    if (SearchType) {
      this._CommonSearch.SearchType = SearchType;
      this._CommonSearch.Searchstring = Searchstring;
      let Result = this._CommonService.GetAutoCompleteResult(this._CommonSearch)
      return Result;
    }
    else {
      return Observable.of([]);
    }
  }


  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  public CloseOrganizationDetails() {
 
    this._router.navigate(['/Service Monitoring Detailed'
      //, {
      //  ServiceName: btoa(JSON.stringify(Userdetails.ServiceName)),
      //  pageName: btoa(JSON.stringify('WebJobDetailsComponent'))
      //}
    ]);


    this._SearchParm = localStorage.getItem('SearchParm');
    if (this._SearchParm != null) {

      this.ResetEntitySearch(this._SearchParm);
    }
  }


   

  public GetDateByQueryString(ServiceName:any)
  {
    this.loading = true;
    var mQuery: string = "";
    mQuery = "where " + 'dt.' + this._AutoImportStatus.GetServiceName + ' like ' + "'%" + ServiceName + "%'";

    this._CommonSearch.SearchQuery = mQuery;
    this._EntityService.GetAutoImportSearchResult(this._CommonSearch).subscribe(res => {
      var data = res;
      if (data.length > 15) {
        this.tableRowWidth = 100;
      }
      else {
        this.tableRowWidth = 99;
      }
      if (!data.Message) {

        this.SearchResult = data;
        this.loading = false;


        let SearchString = [
          { Value: 'First', Text: this._AutoImportStatus.SearchdropFirst },
          { Value: 'Second', Text: this._AutoImportStatus.SearchMatchesFirst },
          { Value: 'Third', Text: this._AutoImportStatus.SearchtextFirst },
          { Value: 'Fourth', Text: this._AutoImportStatus.SearchdropSecond },
          { Value: 'FiFth', Text: this._AutoImportStatus.SearchMatchesSecond },
          { Value: 'Sixth', Text: this._AutoImportStatus.SearchtextSecond }
        ]

        localStorage.setItem('SearchParm', JSON.stringify(SearchString));
        this.setPage(1);

      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
   
  }



  FilterFirstChange(Searchdrop: string) {
    this.SearchdropSecond = [];
    this._displaypropertyname1 = Searchdrop;
    let SearchdropFirstdata: any[] = this._AutoImportStatus.SearchdropSecondList;
    for (let i = 0; i < SearchdropFirstdata.length; i++) {
      if (SearchdropFirstdata[i].Value != Searchdrop) {
        this.SearchdropSecond.push(SearchdropFirstdata[i]);

      }
      else {
        this._SelectedText_1 = SearchdropFirstdata[i].Text;
        this.SearchdropFirst.slice(i, 1);

      }
    }
    this._AutoImportStatus.SearchtextFirst = "";
    if (this._AutoImportStatus.SearchdropFirst == "Status") {
      this._AutoImportStatus.SearchtextFirst = "Active";
      this._AutoImportStatus.SearchMatchesFirst = "Contains";
    }
    else {
      this._AutoImportStatus.SearchMatchesFirst = "Contains";
    }
  }


  
  public FilterSecondChange(Searchdrop: string) {
    
    this._displaypropertyname2 = Searchdrop;
    this.SearchdropFirst = [];
    let SearchdropSeconddata: any[] = this._AutoImportStatus.SearchdropFirstList;
    for (let i = 0; i < SearchdropSeconddata.length; i++) {
      if (SearchdropSeconddata[i].Value != Searchdrop) {
        this.SearchdropFirst.push(SearchdropSeconddata[i]);

      }
      else {
        this._SelectedText_2 = SearchdropSeconddata[i].Text;
        this.SearchdropSecond.slice(i, 1);
      }
    }
    this._AutoImportStatus.SearchtextSecond = "";
    if (this._AutoImportStatus.SearchdropSecond == "Status") {
      this._AutoImportStatus.SearchtextSecond = "Active";
      this._AutoImportStatus.SearchMatchesSecond = "Contains";
    }
    else {
      this._AutoImportStatus.SearchMatchesFirst = "Contains";
    }
  }

  public BtnSearch() {
    this.loading = true;
    var mQuery: string = "";
    var mQuerysecond: string = "";
    

    if (this._AutoImportStatus.AutoImportSearchDate != null) {
      if (!this._AutoImportStatus.AutoImportSearchDate.jsdate) {
        this._AutoImportStatus.AutoImportSearchDate = this._AutoImportStatus.AutoImportSearchDate;
      } else {
        this._AutoImportStatus.AutoImportSearchDate = formatDate(this._AutoImportStatus.AutoImportSearchDate.jsdate);
      }

    }
    else {
      this.toastr.error('Please select date.');
      this.loading = false;
      return;
    }
    if ((this._AutoImportStatus.SearchdropFirst != "-1") || (this._AutoImportStatus.SearchdropSecond != "-1")) {

      let pattern = new RegExp(/^[- a-z. 0-9 _ < > & $ % @ * ~ ! ^ + = : ; , | ( ) ? { } \/ ! # ]+$/i)
      var SearchFirst = true;
      var SearchSecond = true;
      SearchFirst = pattern.test(this._AutoImportStatus.SearchtextFirst);
      SearchSecond = pattern.test(this._AutoImportStatus.SearchtextSecond);
      /***********************First Drop Down ****************************************/
      if (this._AutoImportStatus.SearchdropFirst != "-1") {

        if (this._AutoImportStatus.SearchtextFirst != undefined && this._AutoImportStatus.SearchtextFirst != "") {

          if (SearchFirst == true) {
            if (this._AutoImportStatus.SearchMatchesFirst == "Contains") {
              mQuery = "where " + 'dt.' + this._AutoImportStatus.SearchdropFirst + ' like ' + "'%" + this._AutoImportStatus.SearchtextFirst + "%'" + " and " + 'RunDate <=' + "'" + this._AutoImportStatus.AutoImportSearchDate + "'";
            }
            else if (this._AutoImportStatus.SearchMatchesFirst == "Exact") {
              mQuery += "where " + 'dt.' + this._AutoImportStatus.SearchdropFirst + ' = ' + "'" + this._AutoImportStatus.SearchtextFirst + "'" + " and " + 'RunDate <=' + "'" + this._AutoImportStatus.AutoImportSearchDate + "'";
            }
          }
          else {
            this.loading = false;
            this.toastr.error("Please enter valid characters in " + this._SelectedText_1 + " search");
            return;
          }
        }
        else {
          /********* ShowWriteToastMessage ******/

          this.toastr.error('Please enter the ' + this._SelectedText_1 + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/

          return;
        }
      }

      
      if (this._AutoImportStatus.SearchdropSecond != "-1") {

        if (this._AutoImportStatus.SearchtextSecond != undefined && this._AutoImportStatus.SearchtextSecond != "") {
          if (SearchSecond == true) {
            if (mQuery == "") {
              mQuery += " where "
            }
            else {
              mQuery += " and "
            }

            if (this._AutoImportStatus.SearchMatchesSecond == "Contains") {
              mQuery += 'dt.' + this._AutoImportStatus.SearchdropSecond + ' like ' + "'%" + this._AutoImportStatus.SearchtextSecond + "%'" + " and " + 'RunDate <=' + "'" + this._AutoImportStatus.AutoImportSearchDate + "'";
            }
            else if (this._AutoImportStatus.SearchMatchesSecond == "Exact") {
              mQuery += 'dt.' + this._AutoImportStatus.SearchdropSecond + ' = ' + "'" + this._AutoImportStatus.SearchtextSecond + "'" + " and " + 'RunDate <=' + "'" + this._AutoImportStatus.AutoImportSearchDate + "'";
            }
          }
          else {
            this.loading = false;
            this.toastr.error("Please enter valid characters in " + this._SelectedText_2 + " search");
            return;
          }
        }

        else {
          /********* ShowWriteToastMessage ******/

          this.toastr.error('Please enter the ' + this._SelectedText_2 + '.');
          this.loading = false;
          /********* SetRightToastMessage ******/

          return;
        }
      }
    }
    else {
         //*****************Code for Date Filter******************//
     // if (this._AutoImportStatus.QueryDecriptSName != "") {
        if (this._AutoImportStatus.AutoImportSearchDate != null) {
         // mQuery += "where " + 'dt.' + 'RunDate <=' + "'" + this._AutoImportStatus.AutoImportSearchDate + "'";
          this._CommonSearch.SearchQuery = this._AutoImportStatus.AutoImportSearchDate;

          this._EntityService.GetAutoImportSearchResultbyDate(this._CommonSearch).subscribe(res => {
            var data = res;
            this.isFirstTime = false;
            if (data.length > 15) {
              this.tableRowWidth = 100;
            }
            else {
              this.tableRowWidth = 99;
            }
            if (!data.Message) {

              this.SearchResult = data;
              console.log(this.SearchResult);
              this.loading = false;
              this.isFirstTime = false;

              let SearchString = [
                { Value: 'First', Text: this._AutoImportStatus.SearchdropFirst },
                { Value: 'Second', Text: this._AutoImportStatus.SearchMatchesFirst },
                { Value: 'Third', Text: this._AutoImportStatus.SearchtextFirst },
                { Value: 'Fourth', Text: this._AutoImportStatus.SearchdropSecond },
                { Value: 'FiFth', Text: this._AutoImportStatus.SearchMatchesSecond },
                { Value: 'Sixth', Text: this._AutoImportStatus.SearchtextSecond }
              ]

              localStorage.setItem('SearchParm', JSON.stringify(SearchString));
              this.setPage(1);

            }
            else {
              this.toastr.error(data.Message);
              this.loading = false;
            }
          })

        }
        //this.toastr.error('Please select at least one criteria.');
        //this.loading = false;
        return;
      //} else {
      //}
    }

    this._CommonSearch.SearchQuery = mQuery; 
    this._EntityService.GetAutoImportSearchResult(this._CommonSearch).subscribe(res => {
      var data = res;
      this.isFirstTime = false;
      if (data.length > 15) {
        this.tableRowWidth = 100;
      }
      else {
        this.tableRowWidth = 99;
      }
      if (!data.Message) {

        this.SearchResult = data;
        console.log(this.SearchResult);
        this.loading = false;


        let SearchString = [
          { Value: 'First', Text: this._AutoImportStatus.SearchdropFirst },
          { Value: 'Second', Text: this._AutoImportStatus.SearchMatchesFirst },
          { Value: 'Third', Text: this._AutoImportStatus.SearchtextFirst },
          { Value: 'Fourth', Text: this._AutoImportStatus.SearchdropSecond },
          { Value: 'FiFth', Text: this._AutoImportStatus.SearchMatchesSecond },
          { Value: 'Sixth', Text: this._AutoImportStatus.SearchtextSecond }
        ]

        localStorage.setItem('SearchParm', JSON.stringify(SearchString));
        this.setPage(1);

      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })



  }

  
  ResetEntitySearch(_SearchString: string) {
   
    let Parm = JSON.parse(_SearchString);
    this._AutoImportStatus.SearchdropFirst = Parm[0].Text;
    this._AutoImportStatus.SearchMatchesFirst = Parm[1].Text;
    this._AutoImportStatus.SearchtextFirst = Parm[2].Text;
    this._AutoImportStatus.SearchdropSecond = Parm[3].Text;
    this._AutoImportStatus.SearchMatchesSecond = Parm[4].Text;
    this._AutoImportStatus.SearchtextSecond = Parm[5].Text;
   // this.BtnSearch();
  }




  public ChangeStatus(Val: string) {
    if (Val == "Inactive") {
      Val = "Terminated";
      return Val;
    }
    else {
      Val = "Active";
      return Val;
    }
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.getPager(this.SearchResult.length, page);

    // get current page of items
    this.pagedItems = this.SearchResult.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = _.range(startPage, endPage + 1);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages
    }
  }

  
}


function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}



// WEBPACK FOOTER //
// ./src/app/AutoImportStatus/AutoImportSearch.component.ts